import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createUpdatePageDisplayedTechnicalThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.UpdatePageDisplayedTechnical,
    async ({ applicationId, pageVariableToUpdate }: { applicationId: string, pageVariableToUpdate: string }) => {
      const response = await api.updatePageDisplayedTechnical(applicationId, pageVariableToUpdate);
      return response;
    },
  );
